import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './Header';
import EducationBlock from './EducationBlock';
import Footer from './Footer';
import Hero from './Hero';
import About from './About';
import Courses from './Courses';
import Advantages from './Advantages';
import Testimonials from './Testimonials';

// Օգնող կոմպոնենտ էջը վերև բարձրացնելու համար
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function Home() {
  return (
    <div className='home-wrapper'>
      <ScrollToTop />
      <Header />

      <main className='content-area'>
        <Routes>
          {/* Գլխավոր էջ */}
          <Route path="/" element={
            <div className='landing-page'>
              <Hero />
              <div className="container">
                <About />
                <Courses />
                <Advantages />
                <Testimonials />
              </div>
            </div>
          } />

          {/* Դինամիկ էջ (օրինակ՝ /web, /hair) */}
          <Route path="/:sectionId" element={<EducationBlock />} />

          {/* 404 էջ (ըստ ցանկության) */}
          <Route path="*" element={<div style={{ padding: '100px', textAlign: 'center' }}>Էջը չի գտնվել</div>} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}